import React, { Component } from 'react';

var CardSkill = React.createClass({
  getInitialState: function(){
    return {
      openChange: false
    }
  },
  openChange: function(){
    this.setState({
      openChange: !this.state.openChange
    })
  },
  render: function(){
    var skill = this.props.skill;
    if(!this.state.openChange){
      return(
        <div className="User">
          <div style={{marginBottom: 10}}>Название навыка - {skill.nameSkill}</div>
          <div style={{marginBottom: 10}}>Проходной балл - {skill.minBall}</div>
          <div>Тип теста - {skill.typeSkill === 0 ? 'Технический' : skill.typeSkill === 1 ? 'Психологический' : 'Опросник'}</div>
          <div className="change" style={{right: 0, padding: '0 5px'}} onClick={this.openChange}>Изменить</div>
        </div>
      );
    }else{
      return (
        <CreateChangeSkill openChange={this.openChange} saveSkills={this.props.saveSkills} skills={this.props.skills} change={skill.id} />
      )
    }
    
  }
})

var CreateChangeSkill = React.createClass({
  getInitialState: function(){
    if(typeof this.props.change != 'undefined'){
      var skill;
      this.props.skills.forEach(element => {
        if(element.id == this.props.change){
          skill = element;
        }
      });
      return {
        skills: this.props.skills,
        openCreateSkill: true,
        nameSkill: skill.nameSkill,
        minBall: skill.minBall,
        typeSkill: skill.typeSkill,
        change: true
      }
    }else{
      return {
        skills: this.props.skills,
        openCreateSkill: this.props.skills && this.props.skills.length ? false : true,
        nameSkill: '',
        minBall: '',
        typeSkill: 0
      }
    }
  },
  openOrCloseCreateSkill: function(){

    var result = {openCreateSkill: !this.state.openCreateSkill, skills: this.state.skills};

    
    if(!/^\d+$/.test(this.state.minBall) && this.state.openCreateSkill){
      this.setState({error: true});
      return;
    }

    if(result.openCreateSkill === false && this.state.nameSkill && this.state.minBall){
      if(this.state.change){
        for(var element of this.props.skills){
          if(element.id == this.props.change){
            element.nameSkill = this.state.nameSkill;
            element.minBall = this.state.minBall;
            element.typeSkill = this.state.typeSkill;
          }
        }
      }else{
        result.skills.push({
          nameSkill: this.state.nameSkill,
          minBall: this.state.minBall,
          id: result.skills.length,
          typeSkill: this.state.typeSkill
        })
      }
      

      result.nameSkill = '';
      result.minBall = '';
      result.typeSkill = 0;
    }

    if(this.state.change){
      this.props.openChange()
    }

    this.props.saveSkills(result.skills)

    this.setState(result)
  },
  changeNameSkill: function(e){
    this.setState({nameSkill: e.target.value, error: false})
  },
  changeMinBall: function(e){
    this.setState({minBall: e.target.value, error: false})
  },
  changeTypeSkill: function(type){
    this.setState({typeSkill: type, error: false})
  },
  render: function(){
    if(this.state.openCreateSkill){
      return(
        <div className={this.state.error ? "User error" : "User"}>
          <h1 className="headline">{this.state.change ? 'Изменение навыка' : 'Создание навыка'}</h1>

          <input placeholder="Название навыка" value={this.state.nameSkill} onChange={this.changeNameSkill} />
          <input placeholder="Проходной балл" value={this.state.minBall} onChange={this.changeMinBall} />
          <div className="chekerWrapper">
            <div className="cheker" onClick={()=> this.changeTypeSkill(0)} style={{background: this.state.typeSkill === 0 ? '#60a0f5' : '#fff'}}>Технический</div>
            <div className="cheker" onClick={()=> this.changeTypeSkill(1)} style={{background: this.state.typeSkill === 1 ? '#60a0f5' : '#fff'}}>Психологический</div>
            <div className="cheker" onClick={()=> this.changeTypeSkill(2)} style={{background: this.state.typeSkill === 2 ? '#60a0f5' : '#fff'}}>Опросник</div>
          </div>
          <div onClick={this.openOrCloseCreateSkill} className="SelectSpecialtiesOpen">{this.state.change ? 'Измененить навык' : 'Создать навык'}</div>
      </div>
      )
    }else{
      return(
        <div onClick={this.openOrCloseCreateSkill} className="SelectSpecialtiesOpen">{this.state.change ? 'Измененить навык' : 'Создать навык'}</div>
      )
    }
  }
})


var CreateSkills = React.createClass({
  getInitialState: function(){
    return {
      open: false,
      skills: this.props.skills || [],
    }
  },

  // handlerAddSpecialty: function(id){

  //   console.log('this.props.specialties[id]', this.props.specialties[id])
  //   this.props.onSelectSpecialty(this.props.specialties[id])

  //   this.openOrClose();
  // },
  openOrClose: function(){
    this.props.saveSkills(this.state.skills);
    this.setState({open: !this.state.open})
  },

  saveSkills: function(newSkills){
    this.setState({skills: newSkills});
  },
  
  render: function(){
    if(this.state.open){
      return(
        <div className="Specialties" style={{width: '80%'}}>
          <div onClick={this.openOrClose} className="SelectSpecialtiesOpen top">Сохранить</div>
          
          <CreateChangeSkill saveSkills={this.saveSkills} skills={this.state.skills} />
          
          <div className="UserList">
            {this.state.skills.map((skill, i) => {
              return (
                <CardSkill saveSkills={this.saveSkills} skills={this.state.skills} key={i} skill={skill} />
              )
            })}
          </div>
        </div>
      );
    }else{
      return(
        <div onClick={this.openOrClose} className="SelectSpecialtiesOpen">{this.state.skills.length ? 'Создать/изменить навыки (' + this.state.skills.length + ')'  : 'Создать навыки'}</div>
      );
    }
  }
});

export default CreateSkills;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/components/CreateSkill/index.jsx
 **/